import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class WebMenuMemberService extends Service {
    constructor() {
        super();
        this.baseURL = 'product/webmenumember';
    }

    async getActiveWebMenuShortcutsForMemberByBranchId(branchId) {
        let url = SERVER_URL + this.baseURL + "/status/active/member/shortcuts/" + branchId;
        const params = new URLSearchParams();
        const orderType = localStorage.getItem("orderType");
        const tableBssId = GeneralUtils.getParameterByName('tableBssId');
        if (orderType === "Table Order" && !GeneralUtils.isNullOrEmpty(tableBssId)) {
            params.append("orderType", orderType);
            params.append("tableBssId", tableBssId);
        }
        const query = params.toString();
        if (query) {
            url += "?" + query;
        }
        return fetch(url, {
            headers: {'Content-Type': 'application/json'}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notificationPayNoAttention(error);
        });
    }

    async getWebMenuItemsByParentId(merchantBranchId, parentId, offset = 0, limit = 30) {
        const url = `${SERVER_URL}${this.baseURL}/status/active/member/${merchantBranchId}/${parentId}?offset=${offset}&limit=${limit}`;
        return fetch(url, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => {
                GeneralUtils.notification(error);
            });
    }


    async getActiveSubWebMenuShortcutsForMemberByParentId(merchantBranchId, parentId, offset = 0, limit = 30) {
        const url = `${SERVER_URL}${this.baseURL}/status/active/member/shortcuts/${merchantBranchId}/parentid/${parentId}?offset=${offset}&limit=${limit}`;

        return fetch(url, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => {
                GeneralUtils.notification(error);
            });
    }


    async findBySearchText(branchId, name) {
        return fetch(SERVER_URL + this.baseURL + "/status/active/member/" + branchId + "/name/" + name, {
            headers: {'Content-Type': 'application/json'}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }


}